import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col } from 'react-bootstrap';

import Card from '../../organisms/Card';
import Form from '../../organisms/category/CategoryForm';
import ConfirmForm from '../../organisms/category/EditConfirmForm';
import RegisterCompleteModal from '../../organisms/RegisterCompleteModal';

import routes from './routePath';

class CategoryEdit extends React.Component {
  static get propTypes() {
    return {
      children: PropTypes.any,
      state: PropTypes.shape({
        isLoading: PropTypes.bool,
        categorySearch: PropTypes.shape({
          searchValues: PropTypes.shape({
            values: PropTypes.object,
            searchParams: PropTypes.object,
          }),
        }),
        categoryEdit: PropTypes.shape({
          isConfirm: PropTypes.bool,
          isComplete: PropTypes.bool,
          isError: PropTypes.bool,
          errorMessages: PropTypes.object,
        }),
      }),
      match: PropTypes.shape({
        params: PropTypes.shape({ id: PropTypes.string }),
      }),
      initCategoryEdit: PropTypes.func,
      initState: PropTypes.func,
      updateCategory: PropTypes.func,
      history: PropTypes.shape({
        push: PropTypes.func,
      }),
      backToInput: PropTypes.func,
      setEditValues: PropTypes.func,
      search: PropTypes.func,
      initReferState: PropTypes.func,
    };
  }

  constructor(props) {
    super(props);

    this.confirm = this.confirm.bind(this);
    this.transitionToRefer = this.transitionToRefer.bind(this);
    this.backToInput = this.backToInput.bind(this);
    this.submit = this.submit.bind(this);
    this.transitionToBack = this.transitionToBack.bind(this);
    this.transitionToSearch = this.transitionToSearch.bind(this);
    this.isNew = this.isNew.bind(this);
    this.onCloseCompleteModal = this.onCloseCompleteModal.bind(this);

    this.state = { values: {} };
  }

  componentDidMount() {
    const { params } = this.props.match;
    this.id = params.id;

    this.props.initCategoryEdit(this.id);
  }

  isNew() {
    console.debug('CategoryEdit isNew: ', !this.id);
    return !this.id;
  }

  confirm(values) {
    console.debug('values', values);

    this.setState({ values: values });

    this.props.setEditValues(values);
  }

  submit() {
    console.debug('submit values: ', this.state.values);

    this.props.updateCategory({
      ...this.state.values,
      id: this.id,
    });
  }

  onCloseCompleteModal() {
    const {
      values,
      searchParams,
    } = this.props.state.categorySearch.searchValues;
    console.debug('values, ', values, 'searchParams', searchParams);
    if (
      (values && Object.keys(values).length > 0) ||
      (searchParams && Object.keys(searchParams).length > 0)
    ) {
      this.props.search(values, searchParams);
    }

    this.transitionToBack();
  }

  transitionToRefer(id) {
    this.props.history.push(routes.refer(id));
  }

  transitionToSearch() {
    this.props.history.push(routes.search);
  }

  transitionToBack() {
    const id = this.id;

    if (id) {
      this.transitionToRefer(id);
    } else {
      this.transitionToSearch();
    }

    // this.props.initReferState();
  }

  backToInput() {
    this.props.backToInput();
  }

  render() {
    const isConfirm = () => {
      return this.props.state.categoryEdit.isConfirm;
    };

    return (
      <>
        <section className="section">
          <div className="section-header">
            <h1>カテゴリ管理</h1>
          </div>

          <div className="section-body">
            <Row>
              <Col>
                <Card headerTitle="編集">
                  {isConfirm() ? (
                    <ConfirmForm
                      onSubmit={this.submit}
                      backToInput={this.backToInput}
                      values={this.state.values}
                      isNew={this.isNew()}
                    />
                  ) : (
                    <Form
                      onSubmit={this.confirm}
                      onPrevButtonClick={this.transitionToBack}
                      isNew={this.isNew()}
                      isError={this.props.state.categoryEdit.isError}
                      messages={this.props.state.categoryEdit.errorMessages}
                    />
                  )}
                </Card>
              </Col>
            </Row>
          </div>
        </section>

        <RegisterCompleteModal
          show={this.props.state.categoryEdit.isComplete}
          onCloseClick={this.onCloseCompleteModal}
        />
      </>
    );
  }
}

export default CategoryEdit;
